import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../../lib/api";
import { Bot, MessageSquare, ChevronRight, RefreshCw } from "lucide-react";

const PRIORITY_STYLE = {
  prioridade_humana: "bg-red-100 text-red-700 border-red-200",
  atencao: "bg-amber-100 text-amber-800 border-amber-200",
  normal: "bg-violet-100 text-violet-700 border-violet-200",
};

export default function CentralCasesWidget() {
  const [cases, setCases] = useState([]);
  const [loading, setLoading] = useState(true);
  const [onlyMine, setOnlyMine] = useState(false);

  const load = async () => {
    setLoading(true);
    try {
      const r = await api.get(`/consultant/me/central-cases?only_mine=${onlyMine}`);
      setCases(r.data || []);
    } catch { setCases([]); }
    finally { setLoading(false); }
  };
  useEffect(() => { load(); }, [onlyMine]); // eslint-disable-line react-hooks/exhaustive-deps

  if (loading && !cases.length) return null;
  if (!cases.length && !loading) return null;

  return (
    <section className="bg-white border border-slate-200 rounded-xl p-5 mb-4" data-testid="central-cases-widget">
      <div className="flex items-center justify-between mb-4 flex-wrap gap-2">
        <div>
          <h2 className="font-display font-semibold text-lg text-[#0B2B62] flex items-center gap-2">
            <Bot className="w-5 h-5 text-violet-600" /> Casos da LIA
          </h2>
          <p className="text-xs text-slate-500 mt-0.5">Famílias que chegaram pela Central IA e viraram caso</p>
        </div>
        <div className="flex items-center gap-3 text-xs">
          <label className="inline-flex items-center gap-1.5 cursor-pointer" data-testid="lia-cases-only-mine">
            <input type="checkbox" checked={onlyMine} onChange={(e) => setOnlyMine(e.target.checked)} className="rounded" />
            <span>Somente meus</span>
          </label>
          <button onClick={load} disabled={loading} className="text-slate-500 hover:text-[#0B2B62] disabled:opacity-40" data-testid="lia-cases-refresh">
            <RefreshCw className={`w-4 h-4 ${loading ? "animate-spin" : ""}`} />
          </button>
        </div>
      </div>
      <div className="space-y-2 max-h-[420px] overflow-y-auto pr-1">
        {cases.slice(0, 20).map((c) => {
          const prioCls = PRIORITY_STYLE[c.priority_level] || PRIORITY_STYLE.normal;
          return (
            <Link
              key={c.id}
              to={`/consultor/caso/${c.id}`}
              data-testid={`lia-case-${c.protocol}`}
              className="flex items-start gap-3 p-3 border border-slate-200 rounded-lg hover:bg-slate-50 hover:border-slate-300 transition"
            >
              <div className={`w-9 h-9 rounded-full flex items-center justify-center shrink-0 border ${prioCls}`}>
                <MessageSquare className="w-4 h-4" />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <span className="font-semibold text-sm text-[#0B2B62]">{c.protocol}</span>
                  {c.mine && (
                    <span className="text-[10px] px-1.5 py-0.5 rounded bg-emerald-100 text-emerald-700 font-semibold">
                      Meu
                    </span>
                  )}
                  {c.priority_label && (
                    <span className="text-[10px] text-slate-500">· {c.priority_label}</span>
                  )}
                </div>
                <div className="text-xs text-slate-600 mt-1">
                  {c.patient_name || "A confirmar"} · {c.patient_age || "?"} anos · {c.city || "cidade não informada"}
                </div>
                {c.intake_summary && (
                  <div className="text-xs text-slate-500 mt-1 line-clamp-2">{c.intake_summary}</div>
                )}
                <div className="flex items-center gap-2 mt-1 text-[10px] text-slate-400 flex-wrap">
                  {c.financial_label && <span>💰 {c.financial_label}</span>}
                  {c.family_intent && <span>· {c.family_intent}</span>}
                  {c.source_conversation_id && <span>· 🤖 Central</span>}
                </div>
              </div>
              <ChevronRight className="w-4 h-4 text-slate-300 shrink-0 mt-1" />
            </Link>
          );
        })}
      </div>
    </section>
  );
}
